<template>
  <slot></slot>
</template>

<script setup lang="ts">
import { useProvideChat } from "@/stores/chat/services/use-chat";
import { computed } from "vue";

const props = defineProps<{
  chatRoomId: string;
}>();

useProvideChat({ roomId: computed(() => props.chatRoomId) });
</script>
